import { useEffect, useState } from "react";
import { History, ChevronDown, ChevronRight, CheckCircle2, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.round((b || 0) / 1024)} KB`);
const when = (iso) => new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
const short = (p) => p.split("/").pop();

// Last 20 sync runs: what files were copied to the live site, or why a run failed.
export function SyncHistory({ refreshKey }) {
  const [runs, setRuns] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/admin/livesync/history").then((r) => setRuns(r.data)).catch(() => {}); }, [refreshKey]);
  if (!runs.length) return null;
  return (
    <div data-testid="sync-history" className="space-y-1">
      <p className="text-xs font-medium flex items-center gap-1.5 text-muted-foreground"><History size={13} /> Sync history (last {runs.length})</p>
      <ul className="divide-y rounded-xl border text-xs">
        {runs.map((r, i) => {
          const files = r.copied || [];
          const expandable = files.length > 0 || (r.file_errors || []).length > 0;
          return (
            <li key={r.at + i} data-testid={`sync-run-${i}`}>
              <button type="button" onClick={() => expandable && setOpen(open === i ? null : i)} className={`w-full flex items-center gap-2 px-3 py-2 text-left ${expandable ? "hover:bg-muted/50" : "cursor-default"}`}>
                {r.ok ? <CheckCircle2 size={13} className="text-emerald-600 shrink-0" /> : <AlertTriangle size={13} className="text-amber-600 shrink-0" />}
                <span className="w-36 shrink-0 text-muted-foreground">{when(r.at)}</span>
                <span className="flex-1 truncate">
                  {r.ok ? <>{r.reason} · <b>{r.files_sent}</b> file{r.files_sent === 1 ? "" : "s"} copied{r.files_sent ? ` (${fmt(files.reduce((s, f) => s + f.bytes, 0))})` : ""}{r.file_errors?.length ? <span className="text-amber-700"> · {r.file_errors.length} failed</span> : null}</> : <span className="text-amber-700">{r.reason} · failed: {r.error}</span>}
                </span>
                {expandable && (open === i ? <ChevronDown size={13} /> : <ChevronRight size={13} />)}
              </button>
              {open === i && (
                <ul className="px-3 pb-2 pl-9 space-y-0.5 text-muted-foreground">
                  {files.map((f) => <li key={f.path} className="truncate">{f.layer ? <span className="text-foreground">{f.layer}</span> : null}{f.layer ? " · " : ""}{short(f.path)} · {fmt(f.bytes)}</li>)}
                  {(r.file_errors || []).map((f) => <li key={f.path} className="text-amber-700 truncate">{short(f.path)} · {f.error}</li>)}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
